var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7b9c5;}.cls-2{font-size:9.6px;fill:#fff;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5.2 11)"
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMoreIcon);
export default __webpack_public_path__ + "static/media/LearnMoreIcon.34afb3fe31443f13bafa55fcec036aa1.svg";
export { ForwardRef as ReactComponent };